import axios from "axios";

export const client = axios.create({
    baseURL: "https://stirred-rhino-39.hasura.app/api/rest/article",
    headers: {
    "x-hasura-admin-secret": "2T083plTMGttLOXsgGkiRGPW3DPK8ChI49T3g3xy7QbUbvIFyPgJ5o3GTXMYfZTj",
    },
});


export const getArticle = async () => {
    const response = await client.get("/");
    return response.data._onetomany_article;
};